import Insights from "../Insights";
import PopularCities from "../PopularCities";
import TrendingProperties from "../TrendingProperties";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";

const CollectionRailsGroup = ({ isDesktop, fromBaidu }: any) => {
  const { propertyViewedFlag, searchViewedFlag } = useSelector(
    ({ appData }: AppState) => ({
      propertyViewedFlag: appData.propertyViewedFlag,
      searchViewedFlag: appData.searchViewedFlag,
    }),
    shallowEqual,
  );
  const isRepeatUser = propertyViewedFlag || searchViewedFlag;

  return (
    <>
      {isRepeatUser && (
        <>
          <PopularCities isDesktop={isDesktop} />
          {!fromBaidu && <Insights isDesktop={isDesktop} />}

          <TrendingProperties subSectionPaddingReduced isDesktop={isDesktop} />
        </>
      )}
      {!isRepeatUser && (
        <>
          <Insights isDesktop={isDesktop} fromBaidu={fromBaidu} />
          <PopularCities isDesktop={isDesktop} fromBaidu={fromBaidu} />
          {!fromBaidu && <TrendingProperties isDesktop={isDesktop} />}
        </>
      )}
    </>
  );
};

export default wrapperHOC(CollectionRailsGroup, {
  componentName: "CollectionRailsGroup-Home",
  showForChina: true,
});
